<template>
    <ui-field v-bind="this.$props" v-slot="{ id }">
        <input
            ref="input"
            :id="id"
            class="m-0 relative rounded-md block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500"
            :class="[dynamicClasses, field]"
            :placeholder="placeholder"
            :autofocus="autofocus"
            :required="required"
            :disabled="disabled"
            :name="name"
            :value="value"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)"
        >
    </ui-field>
</template>

<script>
import flatpickr from 'flatpickr'

export default {
    props: {
        value: null,
        label: String,
        name: String,
        error: String,
        warning: String,
        info: String,
        placeholder: String,
        autofocus: Boolean,
        required: Boolean,
        disabled: Boolean,
        inline: Boolean,
        field: {type: String, default: 'mt-1 shadow-sm'},
        withTime: Boolean,
        format: String,
        displayFormat: String,
        mode: {type: String, default: 'single'},
        minDate: Date,
        maxDate: Date,
    },
    data() {
        return {
            flatpickr: null,
        }
    },
    computed: {
        dynamicClasses() {
            if (this.error) return 'border-red-300'
            if (this.disabled) return 'border-gray-300 text-gray-500 bg-gray-50'
            return 'border-gray-200 placeholder-gray-400'
        },
        effectiveFormat() {
            return this.format || (this.withTime ? 'Y-m-d H:i' : 'Y-m-d')
        },
        effectiveDisplayFormat() {
            return this.displayFormat || (this.withTime ? 'F J, Y \\a\\t G:iK' : 'F J, Y')
        }
    },
    watch: {
        value(value) {
            this.flatpickr.setDate(value)
        },
    },
    mounted() {
        this.flatpickr = flatpickr(this.$refs.input, {
            enableTime: this.withTime,
            dateFormat: this.effectiveFormat,
            altInput: true,
            inline: this.inline,
            mode: this.mode,
            altFormat: this.effectiveDisplayFormat,
            minDate: this.minDate,
            maxDate: this.maxDate,
            onClose: [(e) => { this.$emit('close', e)}],
        })
    },
    beforeDestroy() {
        this.flatpickr.destroy()
    },
}
</script>
